import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useParticipationCodesQuery = getWrappedUseQuery(
  KEYS.GET_PARTICIPATION_CODES,
  apiClient.ParticipationCodes.get,
);
